
const API = process.env.REACT_APP_API_FOR_LOCAL
export default {
  socketUrl: process.env.REACT_APP_API_FOR_LOCAL,
  baseUrl: `${API}/api/v1/`,
  imageUrl: "https://chatwork-messenger.s3.ap-south-1.amazonaws.com/media/",
  MAP_API_KEY: "AIzaSyDEQIebYfHNcShWiuNae453DktFsFipChw13",
  Google_Map_URL: `https://maps.googleapis.com/maps/api/geocode/json?latlng=`,
};
